import { useState, useEffect, useRef } from "react";
import { PageContainer } from "../components/core/PageContainer";
import { Title } from "../components/core/Title";
import { Skeleton } from "../components/ui/skeleton";

const firebaseStorageBucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
const privacyPolicyUrl = firebaseStorageBucket
  ? `https://firebasestorage.googleapis.com/v0/b/${firebaseStorageBucket}/o/legal%2Fprivacy-policy.pdf?alt=media`
  : "";

const googleViewerUrl = privacyPolicyUrl
  ? `https://docs.google.com/viewer?url=${encodeURIComponent(
      privacyPolicyUrl
    )}&embedded=true`
  : "";

const MAX_RETRIES = 3;
const RETRY_DELAY = 5000; // 5 seconds

export function PrivacyPolicy() {
  const [isLoading, setIsLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const [iframeKey, setIframeKey] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Set a timeout to check if iframe hasn't loaded after 5 seconds
    if (isLoading && retryCount < MAX_RETRIES) {
      timeoutRef.current = setTimeout(() => {
        setRetryCount((prev) => prev + 1);
        setIframeKey((prev) => prev + 1); // Force iframe reload
      }, RETRY_DELAY);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isLoading, retryCount]);

  const handleLoad = () => {
    setIsLoading(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  return (
    <PageContainer className="pb-20">
      <Title showBackButton fallbackUrl="/policies">
        Privacy Policy
      </Title>

      <div className="flex-1 w-full h-full">
        {isLoading && <Skeleton className="h-full w-full" />}

        <iframe
          key={iframeKey}
          src={googleViewerUrl}
          className={`w-full border-0 rounded-lg ${
            isLoading ? "h-0" : "h-full"
          }`}
          title="Privacy Policy"
          onLoad={handleLoad}
        />
      </div>
    </PageContainer>
  );
}
